import { useState } from 'react';
import UserService from './UserService';

const useManageUser = () => {
  const [user, setUser] = useState({
    username: "",
    password: "",
  })
  const [error, setError] = useState(null);
  const [, setLoading] = useState(null);

  const login = async (user) => {
    let result = {}
    setLoading(true);
    try {
      const response = await UserService.login(user);
      result = response.data
    } catch (err) {
      if (err.response) {
      console.log(err.response.data.message)
      result.error = err.response.data.message
      } else {
        // Handle generic error or network issue...
        console.error(err.message);
      }
    } finally {
        setLoading(false);
    }
    return result
  };

  const logout = async () => {
    let result
    setLoading(true);
    try {
      await UserService.logout();
      result = true
    } catch (err) {
      console.log(err.response.data.message)
      result = false
    } finally {
        setLoading(false);
    }
    return result
  };

  const forgotPassword = async () => {
    let result
    setLoading(true);
    try {
      await UserService.forgotPassword();
      result = true
    } catch (err) {
      console.log(err.response.data.message)
      result = false
    } finally {
        setLoading(false);
    }
    return result
  };

  const checkLoginStatus = async (token) => {
    setLoading(true);
    try {
      const response = await UserService.checkLoginStatus()
      return response.data; // true if logged in, false otherwise
    } catch (error) {
      console.error('Error checking login status:', error);
      return false;
    }finally{
      setLoading(false);
    }
  }


  return { user,error, setUser, login, logout, checkLoginStatus, forgotPassword };
}

export default useManageUser;
